import type { DisciplineSchedule } from '@brighterly/lib-core-types/discipline/interfaces'
import type { ProgressReportStore } from '@stores/progress-report/interfaces'

import { getReport } from '@utils/stores/progress-report/getters/report'
import { isFullArray } from '@helpers/array'

const getSchedule = (state: ProgressReportStore): DisciplineSchedule | null => getReport(state)?.schedule || null

export const schedule = {
  getSchedule: (state: ProgressReportStore): DisciplineSchedule | null => getSchedule(state),
  hasSchedule: (state: ProgressReportStore): boolean => isFullArray(getSchedule(state)?.days || []),
}
